import { AxiosInstance, AxiosResponse } from "axios";
import { DemandeAssistanceByNumeroAdhesion } from "../../containers/DepannagePage/selectors";
import { AdhesionApiFactory } from "./swagger";

export interface IApi {
  postDemandeAssistance(
    params: DemandeAssistanceByNumeroAdhesion
  ): Promise<{ url: string }>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const AdhesionApi = AdhesionApiFactory({}, endpoint, axiosClient);

  const postDemandeAssistance = (params): Promise<{ url: string }> =>
    new Promise((resolve, reject) => {
      AdhesionApi.postDemandeAssistanceByNumeroAdhesion(
        params.numeroAdhesion,
        params.demandeAssistance
      )
        .then((response: AxiosResponse<{ url: string }>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });
  return {
    postDemandeAssistance,
  };
};

export default create;
